import VideoPlayer from 'components/VideoPlayer';

interface VideoProps extends Record<string, unknown> {
    url?: string | null;
}

const Video = ({ url }: VideoProps) => <VideoPlayer url={url as string} width={320} />;

export default Video;
